export const imgPath = (id, size) => (
  `https://img.scoutmaps.io/${id}/${size}`
)
